import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { translate } from 'react-i18next';
import Modal from '../../common/Modal';
import Button from '../../common/Button';
import Memos from '../../projects/details/memos';

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noChangeModalDisplayed: false,
      changeModalDisplayed: false,
      displayMemos: false,
      // Simply for forcing the component to re-rerender.
      // Doesn't do anything else.
      displayIdeas: true,
    };
  }
  handleConfirmNoChangeModalOpen = () => {
    this.setState({ noChangeModalDisplayed: true });
  };
  handleConfirmNoChangeModalClose = () => {
    this.setState({
      noChangeModalDisplayed: false,
      displayMemos: false,
    });

    this.handleProjectConfirm();
  };

  handleConfirmChangeModalOpen = () => {
    this.setState({ changeModalDisplayed: true });
  };
  handleConfirmChangeModalClose = () => {
    this.setState({
      changeModalDisplayed: false,
      displayMemos: false,
    });

    this.handleProjectChange();
  };

  handleDisplayIdeas = () => {
    this.setState({ displayIdeas: true });
  };

  renderModal = (isOpen, onRequestClose, title, message) => {
    const { t, project } = this.props;
    const { displayMemos, displayIdeas } = this.state;

    return (
      <Modal isOpen={isOpen} onRequestClose={onRequestClose} title={title}>
        {!displayMemos && (
          <React.Fragment>
            <p>{t('manageUpdates.userStatus.sharePromptMessage')}</p>
            <p className="u-font-italic">{message}</p>
            {displayIdeas && (
              <p>
                <span
                  className="u-cursor-pointer u-color-blue-violet"
                  onClick={this.handleDisplayIdeas}
                >
                  {t('manageUpdates.userStatus.moreIdeasBtn')}
                </span>
              </p>
            )}
            <div className="u-text-center">
              <Button onClick={() => this.setState({ displayMemos: true })}>
                {t('manageUpdates.userStatus.wannaShareBtn')}
              </Button>
              <Button
                styleType="outline"
                className="u-margin-left"
                onClick={onRequestClose}
              >
                {_.sample(
                  t('manageUpdates.userStatus.skipShareBtn', {
                    returnObjects: true,
                  })
                )}
              </Button>
            </div>
          </React.Fragment>
        )}
        {displayMemos && (
          <React.Fragment>
            <Memos
              titleShareBtn={t('manageUpdates.userStatus.shareMoreTitle')}
              triggerCreate
              project={project}
              onSuccess={onRequestClose}
            />
            <Button onClick={onRequestClose}>
              {t('manageUpdates.userStatus.nextBtn')}
            </Button>
          </React.Fragment>
        )}
      </Modal>
    );
  };

  handleProjectConfirm = () => {
    const { project, onAction } = this.props;

    onAction(project._id, 'NO_CHANGE');
  };
  handleProjectChange = () => {
    const { project, onAction } = this.props;

    onAction(project._id, 'CHANGE');
  };

  render() {
    const { project, t } = this.props;
    const { noChangeModalDisplayed, changeModalDisplayed } = this.state;
    return (
      <div className="c-box-primary__box u-display-flex u-justify-content-between u-align-items-center u-padding-vertical">
        <div className="c-box-primary__text">
          <Link
            to={`/projects/${project._id}`}
            className="c-box-primary__link u-color-blue-violet"
          >
            {project.name}
          </Link>
        </div>
        <div className="u-margin-left u-display-flex">
          <button
            data-tip={t('manageUpdates.tooltipNoLongerWorkingOn')}
            data-for="cancel"
            className="c-checkbox-icon u-cursor-pointer c-checkbox-icon--deleted u-margin-right-tiny"
            onClick={this.handleConfirmChangeModalOpen}
          />
          <ReactTooltip id="cancel" className="c-tooltip" effect="float" />
          {this.renderModal(
            changeModalDisplayed,
            this.handleConfirmChangeModalClose,
            t('manageUpdates.userStatus.noLongerWorkingOnTitle', {
              project: project.name,
            }),
            _.sampleSize(
              t('manageUpdates.userStatus.noLongerWorkingOnMessage', {
                returnObjects: true,
              }),
              2
            ).join(' ')
          )}

          <button
            data-tip={t('manageUpdates.tooltipStillWorkingOn')}
            data-for="confirm"
            className="c-checkbox-icon u-cursor-pointer c-checkbox-icon--completed"
            onClick={this.handleConfirmNoChangeModalOpen}
          />
          <ReactTooltip id="confirm" className="c-tooltip" effect="float" />
          {this.renderModal(
            noChangeModalDisplayed,
            this.handleConfirmNoChangeModalClose,
            t('manageUpdates.userStatus.stillWorkingOnTitle', {
              project: project.name,
            }),
            _.sampleSize(
              t('manageUpdates.userStatus.stillWorkingOnMessage', {
                returnObjects: true,
              }),
              2
            ).join(' ')
          )}
        </div>
      </div>
    );
  }
}

export default translate()(Item);



// WEBPACK FOOTER //
// ./src/updates/user-confirm/Item.js